"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.channels.title': 'Channel Integrations',
    'socialMediaPlan.channels.desc': 'Connect and manage your social media accounts.',
};
